import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { SearchActivityService, SearchList } from './search-activity.service';
import { Table } from 'primeng/table';
interface PageEvent {
  first: number;
  rows: number;
}
@Component({
  selector: 'app-search-sds-reports',
  templateUrl: './search-sds-reports.component.html',
  styleUrls: ['./search-sds-reports.component.scss'],
})
export class SearchSdsReportsComponent {
  date!: string;
  firstIndex: number = 0;
  rows: number = 0;
  columns: any[] = [];
  searchTracks: SearchList[] = [];
  rowsPerPage: any;
  totalRecords: number = 0;
  lastIndex!: number;
  pageNumber!: number;
  isSearchListFetching: boolean = false;
  firstTimeSearch: boolean = false;
  currentSortField: string = 'lastAuthentication.asc';
  sortOrder: 'asc' | 'desc' | null = null;
  currentField: string = '';
  searchForm: UntypedFormGroup = new UntypedFormGroup({
    selectedDates: new UntypedFormControl('', []),
    textValue: new UntypedFormControl('', []),
  });
  @ViewChild(Table) table: Table | undefined;

  constructor(
    private spinner: NgxSpinnerService,
    private notifierService: NotifierService,
    private datePipe: DatePipe,
    private searchActivityService: SearchActivityService
  ) {
    this.firstIndex = 0;
    this.rows = 10;
    this.columns = [
      {
        name: 'User Name',
        field: 'userName',
        sortable: true,
      },
      {
        name: 'Search Date',
        field: 'searchDate',
        sortable: true,
      },
      {
        name: 'IP Address',
        field: 'ipAddress',
        sortable: false,
      },
      {
        name: 'Text',
        field: 'text',
        sortable: true,
      },
      {
        name: 'Material Code',
        field: 'materialCode',
        sortable: true,
      },
      {
        name: 'Country',
        field: 'country',
        sortable: true,
      },
      {
        name: 'Language',
        field: 'language',
        sortable: true,
      },
    ];
  }

  ngOnInit(): void {
    this.handleGetSearchList();
    this.spinner.show();

    this.firstTimeSearch = true;
  }
  paginate(event: PageEvent): void {
    this.pageNumber = event.first / event.rows + 1;
  }
  clearText() {
    this.searchForm.controls['textValue'].patchValue('');
    this.searchForm.controls['selectedDates'].patchValue('');
  }
  handleGetSearchList() {
    this.spinner.show();
    this.isSearchListFetching = true;
    this.firstTimeSearch = false;

    const data = this.searchForm.getRawValue();
    this.searchActivityService
      .getSearchActivityResult({
        userName: data.textValue,
        searchDate: data.selectedDates,
      })
      .subscribe((data) => {
        this.searchTracks = [];
        this.handleSearchResponse(data);
        this.spinner.hide();
        this.isSearchListFetching = false;
        this.table?.reset();
      });
    this.spinner.hide();
  }
  handleSearchResponse(data: any) {
    this.searchTracks = data.map((item: SearchList) => {
      return {
        ...item,
        searchDate: this.adjustDateToUserTimezone(item.searchDate),
      };
    });
  }
  adjustDateToUserTimezone(dateString: string): string {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(dateString);
    const userDate = new Date(
      date.toLocaleString('en-US', { timeZone: userTimezone })
    );
    return userDate.toLocaleString();
  }
  onSort(field: string) {
    if (this.currentField.includes(field)) {
      if (this.currentSortField == 'searchDate.asc') {
        this.currentSortField = 'searchDate.desc';
        return;
      }
      // Toggle sort order if the same field is sorted again
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      this.currentSortField = field + '.' + this.sortOrder;
    } else {
      // Set new field and default to ascending order
      this.sortOrder = 'asc';

      this.currentSortField = field + '.' + this.sortOrder;
    }
  }
}
